import { render, staticRenderFns } from "./CoachDialog.vue?vue&type=template&id=3e577b17&scoped=true"
import script from "./CoachDialog.vue?vue&type=script&lang=js"
export * from "./CoachDialog.vue?vue&type=script&lang=js"
import style0 from "./CoachDialog.vue?vue&type=style&index=0&id=3e577b17&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e577b17",
  null
  
)

export default component.exports